import { Swiper } from './swiper-BHBZRieG.js';
import { N as Navigation } from './navigation-CK8lyTSb.js';
import { A as A11y } from './a11y-BuXkunhH.js';
import './utils-DCxzPGFN.js';

class FeaturedBlog extends HTMLElement {
  #swiper = this.querySelector('.swiper');
  #nextButton = this.querySelector('.swiper-next');
  #prevButton = this.querySelector('.swiper-prev');

  connectedCallback() {
    new Swiper(this.#swiper, {
      modules: [A11y, Navigation],
      slidesPerView: 1.2,
      slidesOffsetBefore: 20,
      slidesOffsetAfter: 20,
      spaceBetween: 16,
      navigation: {
        nextEl: this.#nextButton,
        prevEl: this.#prevButton,
      },
      breakpoints: {
        768: {
          slidesPerView: 4,
          slidesOffsetBefore: 40,
          slidesOffsetAfter: 40,
        },
      },
    });
  }
}

customElements.define('featured-blog', FeaturedBlog);
